import {
  AddTask,
  AddTaskComplete,
  AddTasks,
  AddTasksComplete,
  ChangeTaskStatusComplete,
  DeleteTask,
  DeleteTaskComplete,
  LoadTasksComplete,
  UpdateTask,
  UpdateTaskComplete,
} from './task.actions'
import { adapter, initialState, State } from './task.state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadTasksComplete, (state, { tasks }) =>
    adapter.addAll(tasks, R.merge(state, { isLoaded: true, isUpdating: false }))
  ),
  on(AddTaskComplete, (state, { task }) => adapter.addOne(task, R.merge(state, { isUpdating: false }))),
  on(DeleteTaskComplete, (state, { id }) => adapter.removeOne(id, R.merge(state, { isUpdating: false }))),
  on(UpdateTaskComplete, (state, { update }) => adapter.updateOne(update, R.merge(state, { isUpdating: false }))),
  on(ChangeTaskStatusComplete, (state, { update }) => adapter.updateOne(update, R.merge(state, { isUpdating: false }))),
  on(AddTasksComplete, (state, { tasks }) => adapter.addMany(tasks, R.merge(state, { isUpdating: false }))),
  on(AddTask, AddTasks, UpdateTask, DeleteTask, (state) => ({ ...state, isUpdating: true }))
)

export function tasksReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
